/* eslint-disable max-len */
/*
 * @Description:
 * @Version: 1.0
 * @Autor: dudedu
 * @Date: 2022-08-12 15:02:00
 * @LastEditors: dudedu
 * @LastEditTime: 2022-12-09 16:06:57
 */
import i18n from '@/common/locales';
// TENCENT 测试环境 test
export const TEST_ENV = 'openedatest.tefscloud.com';
// TENCENT 开发环境 dev
export const TEST_DEV_ENV = 'openedadev.tefscloud.com';
// staging
export const TEST_STAGING_ENV = 'openedastaging.tefscloud.com';
export const CAE_ENV = 'opencaetest.tefscloud.com';
// TENCENT 开发环境 dev
export const CAE_DEV_ENV = 'opencaedev.tefscloud.com';
// staging
export const CAE_STAGING_ENV = 'opencaestaging.tefscloud.com';

export const PATH_WORKBENCH_OPENCAE = 'https://opencae.cloud.tencent.com/';
export const PATH_WORKBENCH_OPENEDA = 'https://openeda.cloud.tencent.com/';

// PATH_WORKBENCH 主要目录
export const PATH_WORKBENCH = (function () {
  const { host } = window.location;

  if (host.indexOf('opencae') > -1) {
    return PATH_WORKBENCH_OPENCAE;
  }

  return PATH_WORKBENCH_OPENEDA;
}());

export const LOGIN_PATH_MAP = [
  'opencaedev.tefscloud.com',
  'opencaetest.tefscloud.com',
  'opencaestaging.tefscloud.com',
  TEST_DEV_ENV,
  TEST_ENV,
  TEST_STAGING_ENV,
];

export const LOGIN_PATH_WORKBENCH = (function () {
  const { host } = window.location;
  const platform = host.indexOf('opencae') > -1 ? 'cae' : 'eda';
  const loginMap = {
    cae: {
      clouddev: 'opencaedev.tefscloud.com',
      cloudtest: 'opencaetest.tefscloud.com',
      cloudstaging: 'opencaestaging.tefscloud.com',
    },
    eda: {
      clouddev: TEST_DEV_ENV,
      cloudtest: TEST_ENV,
      cloudstaging: TEST_STAGING_ENV,
      qqdev: TEST_DEV_ENV,
      qqtest: TEST_ENV,
      qqstaging: TEST_STAGING_ENV,
    },
  };
  return loginMap[platform];
}());

// 获取用户的登录路径
export const PATH_LOGIN = (function () {
  const { host } = window.location;
  const loginMap = {
    [TEST_DEV_ENV]: 'clouddev',
    [TEST_ENV]: 'cloudtest',
    [TEST_STAGING_ENV]: 'cloudstaging',
    [CAE_DEV_ENV]: 'clouddev',
    [CAE_ENV]: 'cloudtest',
    [CAE_STAGING_ENV]: 'cloudstaging',
  };
  const loginKey = loginMap[host] || 'cloud';
  return `${PATH_WORKBENCH}?state=${loginKey}&code=${loginKey}`;
}());

export const TENCENT_QQ_AUTH_URL = `https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=102003467&redirect_uri=${encodeURI(PATH_WORKBENCH)}`;
export const TENCENT_CLOUD_AUTH_URL = `https://cloud.tencent.com/login?s_url=${encodeURIComponent(`${PATH_WORKBENCH}workbench/monitor?action=agreement`)}`;
export const TENCENT_CLOUD_UNAUTH_URL = `https://cloud.tencent.com/login/quit?s_url=${encodeURIComponent(`${PATH_WORKBENCH}login`)}`;

// 跳转腾讯云链接
export const TENCENT_CLOUD_CREATE_USER_URL = 'https://console.cloud.tencent.com/cam/user/create?systemType=FastCreateV2';

// 帮助中心链接
const HELP_HOME = 'https://eda-static-cdn-1300241787.cos.ap-nanjing.myqcloud.com';
export const HELP_HOME_LINK = `${HELP_HOME}/build/Production/webdoc/1.%E5%88%9B%E5%BB%BA_%E5%8A%A0%E5%85%A5%E5%9B%A2%E9%98%9F.html`;

export const DOWNLOAD_OECLI = 'https://eda-static-cdn-1300241787.file.myqcloud.com/build/Production/oecli/oecli';

// 申请状态 1=待处理 2=已拒绝 3=接受
export const APPLY_PENNING = 1;
export const APPLY_REJECT = 2;
export const APPLY_ACCEPT = 3;

// 环境状态 0=初始化 1=创建中 2=创建失败 3=创建成功
// 环境状态 - 初始化
export const ENV_STATUS_INIT = 0;
// 环境状态 - 初始化
export const ENV_STATUS_CREATING = 1;
// 环境状态 - 创建失败
export const ENV_STATUS_FAIL = 2;
// 环境状态 - 创建成功
export const ENV_STATUS_SUCCESS = 3;
// 环境状态 - 销毁中
export const projectEnvStatusTerminating = 4;
//  环境状态 - 清理数据中
export const projectEnvStatusClearing = 5;
// 环境状态 - 清理数据完成
export const projectEnvStatusCleared = 6;
// 环境状态 - 清理数据失败
export const projectEnvStatusClearFailed = 7;
// 环境状态 - 销毁完成
export const projectEnvStatusTerminated = 8;

/**
 * 实验状态
 *  CvmStatusCreate=创建中 | CvmStatusNormal=正常 | CvmStatusAbnormal=异常
 *  CvmStatusInDestruction=销毁中 | CvmStatusDestruction=已销毁 | CvmStatusInDeployment=部署中
 */
export const CvmStatusFilter = {
  // 创建中
  CvmStatusCreate: 0,
  // 正常
  CvmStatusNormal: 1,
  // 异常
  CvmStatusAbnormal: 2,
  // 销毁中
  CvmStatusInDestruction: 3,
  // 已销毁
  CvmStatusDestruction: 4,
  // 部署中
  CvmStatusInDeployment: 5,
  // 部署失败
  CvmStatusDeploymentFailed: 6,
};

// 状态列表
export const CvmStatusFilterList = [
  {
    label: i18n.t('common.constants.creating'),
    value: '0',
  },
  {
    label: i18n.t('common.constants.normal'),
    value: '1',
  },
  {
    label: i18n.t('common.constants.abnormal'),
    value: '2',
  },
  {
    label: i18n.t('common.constants.destroying'),
    value: '3',
  },
  {
    label: i18n.t('common.constants.destroyed'),
    value: '4',
  },
  {
    label: i18n.t('common.constants.deploying'),
    value: '5',
  },
];
// 队列列表
export const QueueNameFilterList = [
  {
    label: 'login',
    value: 'login',
  },
  {
    label: 'local',
    value: 'local',
  },
  {
    label: 'cpuq',
    value: 'cpuq',
  },
  {
    label: 'gpuq',
    value: 'gpuq',
  },
];
// 节点类型列表
export const NodeTypeFilterList = [
  {
    label: i18n.t('common.constants.masterNode'),
    value: 'master',
  },
  {
    label: i18n.t('common.constants.loginNode'),
    value: 'login',
  },
  {
    label: i18n.t('common.constants.workerNode'),
    value: 'worker',
  },
  {
    label: i18n.t('common.constants.queueNode'),
    value: 'queue',
  },
];

// 计费类型列表
export const BillingTypeDataList = [
  // 计费方式选择
  { value: 'POSTPAID_BY_HOUR', label: i18n.t('computingCluster.resource.postpaid') },
  { value: 'PREPAID', label: i18n.t('computingCluster.resource.prepaid') },
  { value: 'SPOTPAID', label: i18n.t('computingCluster.resource.spotpaid') },
];

// 自定义子集群活动表

//  活动类型 创建实例 活动1
export const SubclusterActivityTypeRunInstances = 1;
// 活动类型 销毁实例 活动2
export const SubclusterActivityTypeTerminateInstances = 2;
//  活动类型 实例开机 活动3
export const SubclusterActivityTypeStartInstances = 3;
//  活动类型 实例关机 活动4
export const SubclusterActivityTypeStopInstances = 4;
//  活动类型 实例重启 活动5
export const SubclusterActivityTypeRebootInstances = 5;
//  活动类型 修改子集群信息 活动6
export const SubclusterActivityTypeModifySubcluster = 6;
//  活动类型 实例绑定弹性网卡7
export const SubclusterActivityTypeAttachNetworkInterface = 7;
//  活动类型 实例解绑弹性网卡8
export const SubclusterActivityTypeDetachNetworkInterface = 8;
//  活动类型 设置初始化脚本 9
export const SubclusterActivityTypeSetInstanceUserdata = 9;

//  活动类型 调整实例配置10
export const SubclusterActivityTypeResetInstanceType = 10;
//  活动类型 修改超线程设置 活动 11
export const SubclusterActivityTypeSetTopology = 11;
//  活动类型 批量创建弹性网卡 12
export const SubclusterActivityTypeCreateNetworkInterface = 12;
//  活动类型 修改计费方式 13
export const SubclusterActivityTypeModifyInstancesChargeType = 13;
// 活动类型 导入实例 14
export const SubclusterActivityTypeImportInstances = 14;
// 活动类型 修改实例续费标识 15
export const SubclusterActivityTypeModifyInstancesRenewFlag = 15;

// SubclusterActivityStatusRunning 活动状态 运行中
export const SubclusterActivityStatusRunning = 1;
// subclusterActivitystatussuccessful 活动状态 运行成功
export const SubclusterActivituStatusSuccessful = 2;
// SubclusterActivitystatusPartiallySuccessful 活动状态 运行部分成功
export const SubclusterActivituStatusPartialluSuccessful = 3;
// SubclusterActivitystatusFailed 活动状态 运行失败
export const SubclusterActivityStatusFailed = 4;

// 任务状态 3=运行中 7=排队中
export const TASK_STATUS_NOT_TEST = '1';
export const TASK_STATUS_CREATING = '2';
export const TASK_STATUS_RUNNING = '3';
export const TASK_STATUS_STOPPING = '4';
export const TASK_STATUS_ERROR = '5';
export const TASK_STATUS_SUCCESS = '6';
export const TASK_STATUS_LINE_UP = '7';

// 项目状态
export const projectFilterStatus = [
  {
    label: i18n.t('common.constants.initialization'),
    value: 0,
    type: 'info',
  },
  {
    label: i18n.t('common.constants.creating'),
    value: 1,
    type: '',
  },
  {
    label: i18n.t('common.constants.abnormal'),
    value: 2,
    type: 'danger',
  },
  {
    label: i18n.t('common.constants.running'),
    value: 3,
    type: 'success',
  },
  {
    label: i18n.t('common.constants.destroying'),
    value: 4,
    type: 'danger',
  },
  {
    label: i18n.t('common.constants.cleaningData'),
    value: 5,
    type: 'warning',
  },
  {
    label: i18n.t('common.constants.dataCleaningCompleted'),
    value: 6,
    type: 'warning',
  },
  {
    label: i18n.t('common.constants.failedCleanData'),
    type: 'danger',
    value: 7,
  },
  {
    label: i18n.t('common.constants.destructionCompleted'),
    type: 'danger',
    value: 8,
  },
];

// 角色权限
// 1- 超级管理员 2-黑名单用户 3-普通用户
export const roleAdmin = 1;
export const roleBlackList = 2;
export const roleNormal = 3;

// 地域对应id
const regionInfo = [
  {
    region: 'ap-guangzhou',
    regionName: '广州',
    id: '1',
  },
  {
    region: 'ap-shenzhen-fsi',
    regionName: '深圳金融',
    id: '11',
  },
  {
    region: 'ap-guangzhou-open',
    regionName: '广州OPEN',
    id: '12',
  },
  {
    region: 'ap-shenzhen',
    regionName: '深圳',
    id: '37',
  },
  {
    region: 'ap-qingyuan',
    regionName: '清远',
    id: '54',
  },
  {
    region: 'ap-qingyuan-xinan',
    regionName: '清远信安',
    id: '73',
  },
  {
    region: 'ap-shenzhen-sycft',
    regionName: '深圳深宇财付通',
    id: '77',
  },
  {
    region: 'ap-guangzhou-wxzf',
    regionName: '广州微信支付',
    id: '82',
  },
  {
    region: 'ap-shenzhen-jxcft',
    regionName: '深圳锦绣财付通',
    id: '84',
  },
  {
    region: 'ap-guangzhou-yg-cft',
    regionName: '广州云谷财付通',
    id: '86',
  },
  {
    region: 'ap-shanghai',
    regionName: '上海',
    id: '4',
  },
  {
    region: 'ap-shanghai-fsi',
    regionName: '上海金融',
    id: '7',
  },
  {
    region: 'ap-jinan-ec',
    regionName: '济南ec',
    id: '31',
  },
  {
    region: 'ap-hangzhou-ec',
    regionName: '杭州ec',
    id: '32',
  },
  {
    region: 'ap-shanghai-ysx',
    regionName: '上海云沙箱',
    id: '13',
  },
  {
    region: 'ap-nanjing',
    regionName: '南京',
    id: '33',
  },
  {
    region: 'ap-fuzhou-ec',
    regionName: '福州ec',
    id: '34',
  },
  {
    region: 'ap-hefei-ec',
    regionName: '合肥ec',
    id: '55',
  },
  {
    region: 'ap-shanghai-adc',
    regionName: '上海自动驾驶云',
    id: '78',
  },
  {
    region: 'ap-shanghai-wxzf',
    regionName: '上海微信支付',
    id: '83',
  },
  {
    region: 'ap-nanjing-xf-cft',
    regionName: '南京学府财付通',
    id: '85',
  },
  {
    region: 'ap-hongkong',
    regionName: '中国香港',
    id: '5',
  },
  {
    region: 'ap-taipei',
    regionName: '中国台北',
    id: '39',
  },
  {
    region: 'na-toronto',
    regionName: '多伦多',
    id: '6',
  },
  {
    region: 'ap-beijing',
    regionName: '北京',
    id: '8',
  },
  {
    region: 'ap-tianjin',
    regionName: '天津',
    id: '36',
  },
  {
    region: 'ap-beijing-fsi',
    regionName: '北京金融',
    id: '46',
  },
  {
    region: 'ap-shijiazhuang-ec',
    regionName: '石家庄ec',
    id: '53',
  },
  {
    region: 'ap-singapore',
    regionName: '新加坡',
    id: '9',
  },
  {
    region: 'ap-bangkok',
    regionName: '曼谷',
    id: '23',
  },
  {
    region: 'ap-jakarta',
    regionName: '雅加达',
    id: '72',
  },
  {
    region: 'na-siliconvalley',
    regionName: '硅谷',
    id: '15',
  },
  {
    region: 'ap-chengdu',
    regionName: '成都',
    id: '16',
  },
  {
    region: 'ap-chongqing',
    regionName: '重庆',
    id: '19',
  },
  {
    region: 'ap-guiyang',
    regionName: '贵阳',
    id: '76',
  },
  {
    region: 'eu-frankfurt',
    regionName: '法兰克福',
    id: '17',
  },
  {
    region: 'eu-moscow',
    regionName: '莫斯科',
    id: '24',
  },
  {
    region: 'ap-seoul',
    regionName: '首尔',
    id: '18',
  },
  {
    region: 'ap-tokyo',
    regionName: '东京',
    id: '25',
  },
  {
    region: 'ap-mumbai',
    regionName: '孟买',
    id: '21',
  },
  {
    region: 'na-ashburn',
    regionName: '弗吉尼亚',
    id: '22',
  },
  {
    region: 'ap-wuhan-ec',
    regionName: '武汉ec',
    id: '35',
  },
  {
    region: 'ap-changsha-ec',
    regionName: '长沙ec',
    id: '45',
  },
  {
    region: 'ap-zhengzhou-ec',
    regionName: '郑州ec',
    id: '71',
  },
  {
    region: 'ap-shenyang-ec',
    regionName: '沈阳ec',
    id: '56',
  },
  {
    region: 'ap-xian-ec',
    regionName: '西安ec',
    id: '57',
  },
  {
    region: 'ap-xibei-ec',
    regionName: '西北ec',
    id: '58',
  },
  {
    region: 'sa-saopaulo',
    regionName: '圣保罗',
    id: '74',
  },
];

const map = new Map();
const map2 = new Map();
regionInfo.forEach((item) => {
  map.set(item.region, item.id);
  map2.set(item.region, item.regionName);
});

export const regionMap = map;
export const regionNameMap = map2;

export const volcengineStatusList = [
  { name: i18n.t('common.constants.creating'), value: 'CREATING' },
  { name: i18n.t('common.constants.running'), value: 'RUNNING' },
  { name: i18n.t('common.constants.stopping'), value: 'STOPPING' },
  { name: i18n.t('common.constants.stopped'), value: 'STOPPED' },
  { name: i18n.t('common.constants.rebooting'), value: 'REBOOTING' },
  { name: i18n.t('common.constants.starting'), value: 'STARTING' },
  { name: i18n.t('common.constants.rebuilding'), value: 'REBUILDING' },
  { name: i18n.t('common.constants.resizing'), value: 'RESIZING' },
  { name: i18n.t('common.constants.error'), value: 'ERROR' },
  { name: i18n.t('common.constants.deleting'), value: 'DELETING' },
];

export const huaweiCloudStatusList = [
  { name: '运行前', value: 'BUILD' },
  { name: '重启中', value: 'REBOOT' },
  { name: '强制重启中', value: 'HARD_REBOOT' },
  { name: '重建中', value: 'REBUILD' },
  { name: '热迁移中', value: 'MIGRATING' },
  { name: '变更中', value: 'RESIZE' },
  { name: '运行中', value: 'ACTIVE' },
  { name: '停止', value: 'SHUTOFF' },
  { name: '回退中', value: 'REVERT_RESIZE' },
  { name: '校验中', value: 'VERIFY_RESIZE' },
  { name: '错误', value: 'ERROR' },
  { name: '已删除', value: 'DELETED' },
  { name: '镜像启动时搁置中', value: 'SHELVED' },
  { name: '卷启动时搁置中', value: 'SHELVED_OFFLOADED' },
];

export const aliyunStatusList = [
  { name: i18n.t('common.constants.creating'), value: 'Pending' },
  { name: i18n.t('common.constants.running'), value: 'Running' },
  { name: i18n.t('common.constants.starting'), value: 'Starting' },
  { name: i18n.t('common.constants.stopping'), value: 'Stopping' },
  { name: i18n.t('common.constants.stopped'), value: 'Stopped' },
];

export const providerOptions = [
  { label: i18n.t('multiCloudCluster.aliyun'), value: 'aliyun' },
  { label: i18n.t('multiCloudCluster.huaweicloud'), value: 'huaweicloud' },
  { label: i18n.t('multiCloudCluster.volcengine'), value: 'volcengine' },
];

export const multiCloudBillingTypeData = [
  // 计费方式选择
  { value: 'PostPaid', text: i18n.t('multiCloudCluster.multiCloudBillingTypeData.postPaid') },
  { value: 'PrePaid', text: i18n.t('multiCloudCluster.multiCloudBillingTypeData.prePaid') },
  // { value: 'SPOTPAID', text: i18n.t('customCluster.createCluster.bidding') },
];


// 地区列表 转义地区
export function filterMultiCloudBillingTypeData(scene) {
  let label = '';
  label = multiCloudBillingTypeData.filter(item => item.value == scene);
  return label[0]?.text || '-';
}

// 计算集群 任务管理 状态 管理

export const taskManageStatusList = {
  // 成功 1
  ClusterTaskStatusSuccess: 1,
  // 失败 2
  ClusterTaskStatusFailed: 2,
  // 运行中 3
  ClusterTaskStatusRunning: 3,
  // 等待中 4
  ClusterTaskStatusPending: 4,
  // 取消 5
  ClusterTaskStatusCanceled: 5,
  // 节点失败 6
  ClusterTaskNodeFailed: 6,
  // 数据加载中 7
  ClusterTaskStatusData: 7,
};
